export { default } from './marketing-spotlight';
